import { useVimeoHtmlProcessor } from "@/hooks/useVimeoHtmlProcessor";
import { VideoPreviewPlayer } from "./VideoPreviewPlayer";

interface ExternalHtmlProps {
	html: string | undefined;
	className?: string;
}

/**
 * Uniwersalny komponent do renderowania zewnętrznego HTML z obsługą embedded Vimeo
 * Wykrywa embedded Vimeo iframe i zastępuje go natywnym playerem przez Vimeo API
 * Renderuje HTML w sekwencji: htmlBeforeVimeo → VideoPreviewPlayer → htmlAfterVimeo
 */
export const ExternalHtml = ({
	html,
	className,
}: ExternalHtmlProps): JSX.Element => {
	const { vimeoId, vimeoData, htmlBeforeVimeo, htmlAfterVimeo, hasFragment, isLoading } =
		useVimeoHtmlProcessor(html);

	return (
		<div className={className}>
			{hasFragment ? (
				<>
					{/* Renderuj HTML przed Vimeo (jeśli istnieje) */}
					{htmlBeforeVimeo && (
						<div
							dangerouslySetInnerHTML={{ __html: htmlBeforeVimeo }}
							className="html-content"
						/>
					)}

					{/* Jeśli znaleziono fragment Vimeo, wyświetl player */}
					{vimeoId && (
						<div className="mb-6">
							{isLoading ? (
								<div className="w-full bg-gray-200 rounded-lg relative flex items-center justify-center" style={{ paddingTop: "56.25%" }}>
									<div className="absolute inset-0 flex items-center justify-center text-gray-600">
										<p>Ładowanie wideo...</p>
									</div>
								</div>
							) : vimeoData ? (
								<VideoPreviewPlayer vimeoId={vimeoId} vimeoData={vimeoData} isLoading={isLoading} />
							) : (
								<div className="w-full bg-gray-200 rounded-lg relative flex items-center justify-center" style={{ paddingTop: "56.25%" }}>
									<div className="absolute inset-0 flex items-center justify-center text-gray-600">
										<p>Nie udało się załadować wideo</p>
									</div>
								</div>
							)}
						</div>
					)}

					{/* Renderuj HTML po Vimeo (jeśli istnieje) */}
					{htmlAfterVimeo && (
						<div
							dangerouslySetInnerHTML={{ __html: htmlAfterVimeo }}
							className="html-content"
						/>
					)}
				</>
			) : (
				/* Jeśli nie znaleziono Vimeo, wyświetl cały HTML normalnie */
				html && (
					<div
						dangerouslySetInnerHTML={{ __html: html }}
						className="html-content"
					/>
				)
			)}
		</div>
	);
};

